import React from 'react';
import { Clear } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

const alert_prior = ['BAJO', 'MEDIO', 'ALTO'];

export const getColumns = (markAttended) => [
  {
    headerName: 'Acción',
    field: ' ',
    renderCell: (params) => {
      return (
        <Tooltip title="Marcar alerta como atendida">
          <IconButton onClick={() => markAttended(params.row)}>
            <Clear />
          </IconButton>
        </Tooltip>
      );
    },
    sortable: false,
  },
  {
    headerName: 'Fecha',
    field: 'created_at',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'Description',
    field: 'description',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'Nivel',
    field: 'level',
    flex: 1,
    sortable: true,
    fontWeight: 'Bold',
    renderCell: (params) => {
      return alert_prior[params.row.lvl - 1] + ' ';
    },
  },
  {
    headerName: 'Ubicación',
    field: 'ubication',
    flex: 1,
    sortable: false,
  },
];
